import { render, staticRenderFns } from "./LinkObject.vue?vue&type=template&id=1fc04a6b&scoped=true"
import script from "./LinkObject.vue?vue&type=script&lang=js"
export * from "./LinkObject.vue?vue&type=script&lang=js"
import style0 from "./LinkObject.vue?vue&type=style&index=0&id=1fc04a6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc04a6b",
  null
  
)

export default component.exports